export const EMPLOYEE_MODAL_INFO = {
  TITLE: 'Envoyer mes données paies',
  TITLE_FOR_EMPLOYEE: 'Transmettre les données de paie de',
  SUBTITLE: 'dernier document envoyé le ',
  LABELS: {
    MONTH_PICKER: 'Choisissez le mois :',
    STATISTICS: 'Données enregistrées :',
  },
  TEXT_AREA_PLACEHOLDER: 'Zone de commentaire (optionnel)',
  SUBMIT_BUTTON: 'Envoyer',
  CANCEL_BUTTON: 'Annuler',
  SUCCESS_MESSAGE:
    'Les informations pour la paie ont bien été envoyées à Exco !',

  WARNING: `Attention, en soumettant ces données, la saisie des variables de paie
        sera bloquée pour tous les salariés sur le mois concerné ; vous pouvez
        déclarer la sortie d’employés et leurs variables de paie en cliquant sur
        l'icône dédiée dans la colonne “Salarié sortant” dans le tableau; en cas
        de modification ou pour toute précision, vous pouvez informer votre
        interlocuteur RH en utilisant le`,
  CONTACT_HR: 'formulaire de contact',
  EMPTY_DECLARATION:
    'Attention, vous allez verrouiller une période sans données, vous ne pourrez plus y saisir d’informations, êtes-vous sûr ?',
};

export const EXCO_INFO_MODAL_DATA_LABELS = {
  totalVacations: 'congés',
  totalAbsences: 'absences',
  totalRewards: 'variables de paie',
};

export const SALARY_MAIN_PAGE = {
  SECTION_TITLE: 'Mes Ressources Humaines',
};
